import React, { Component } from "react";
import DropDown from "../../common/dropDown/dropDown";
import StyleExpoArea from "./styleExpoArea";
import MultiLineHolder from "./multilineHolder";
import SkittleHolder from "./skittleHolder";
import WithCard from "../../../../common/withCard";

class styleExposureHolder extends Component {
  state = {
    selected: "asset_class_stock_place2",
    options: [
      {
        name: "asset_class_stock_place2",
        text: "Area Chart",
        icon: "fa-area-chart fs_icon_option"
      },
      {
        name: "multi2",
        text: "Line Chart",
        icon: "fa-line-chart fs_icon_option"
      },
      {
        name: "skittleChart",
        text: "Skittle Chart",
        icon: "fa-th fs_icon_option"
      }
    ],
    style: { left: "-150px", right: "20px" }
  };

  onclickHandler = e => {
    e.preventDefault();
    this.props.styleHamburgerHandler(e.target.name);
    if (e.target.name) {
      this.setState({
        selected: e.target.name
      });
    }
  };

  render() {
    const { selected, options, style } = this.state;
    const { res } = this.props;
    return (
      <WithCard>
        <div className="asset_classHead">
          <h4 className="text-uppercase bold">Style Exposure</h4>
          {options ? (
            <DropDown
              onclickHandler={this.onclickHandler}
              data={options}
              style={style}
            />
          ) : null}
        </div>
        <div>
          {selected === "asset_class_stock_place2" ? (
            <StyleExpoArea res={res} />
          ) : null}
          {selected === "multi2" ? <MultiLineHolder res={res} /> : null}
          {selected === "skittleChart" ? <SkittleHolder res={res} /> : null}
        </div>
      </WithCard>
    );
  }
}

export default styleExposureHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/StyleExposure/styleExposureHolder.jsx